import React, { useContext, memo } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { Autocomplete, TextField } from '@totalsoft/rocket-ui';
import { RightsContext } from 'providers/RightsContext';

export const OfferFinancialServicesHeaderComponent = ({ t, validationInfo, wheelSizes, onHeaderPropertyChange, header }) => {
  const { readOnlyFull, financialServicesWrite, insurancesRead } = useContext(RightsContext);
  return (
    <>
      {insurancesRead ? (
        <Grid item xs={12} sm={6}>
          <TextField
            id={'offerFinancialServicesCard_km'}
            fullWidth
            isNumeric
            value={header.km || ''}
            inputProps={{ decimalScale: 0 }}
            onChange={onHeaderPropertyChange('km')}
            label={t('OfferEdit.FinancialServices.Km') || ''}
            error={validationInfo.header.km ? true : false}
            helperText={validationInfo.header.km}
            disabled={readOnlyFull || header.productKmReadOnly || !financialServicesWrite}
          />
        </Grid>
      ) : (
        <Grid item xs={12} sm={3}>
          <TextField
            id={'offerFinancialServicesCard_km'}
            fullWidth
            isNumeric
            value={header.km || ''}
            inputProps={{ decimalScale: 0 }}
            onChange={onHeaderPropertyChange('km')}
            label={t('OfferEdit.FinancialServices.Km') || ''}
            error={validationInfo.header.km ? true : false}
            helperText={validationInfo.header.km}
            disabled={readOnlyFull || header.productKmReadOnly || !financialServicesWrite}
          />
        </Grid>
      )}
      {insurancesRead ? (
        <Grid item xs={12} sm={6}>
          <Autocomplete
            id={'offerFinancialServicesCard_wheelsSize'}
            label={t('OfferEdit.FinancialServices.WheelsSize')}
            fullWidth
            labelKey='wheelSize'
            valueKey='wheelSize'
            value={header.wheelSize || ''}
            isSearchable={false}
            simpleValue
            isClearable
            onChange={onHeaderPropertyChange('wheelSize')}
            options={wheelSizes}
            disabled={readOnlyFull || !financialServicesWrite}
          />
        </Grid>
      ) : (
        <Grid item xs={12} sm={3}>
          <Autocomplete
            id={'offerFinancialServicesCard_wheelsSize'}
            label={t('OfferEdit.FinancialServices.WheelsSize')}
            fullWidth
            labelKey='wheelSize'
            valueKey='wheelSize'
            value={header.wheelSize || ''}
            isSearchable={false}
            simpleValue
            isClearable
            onChange={onHeaderPropertyChange('wheelSize')}
            options={wheelSizes}
            disabled={readOnlyFull || !financialServicesWrite}
          />
        </Grid>
      )}
    </>
  );
};

OfferFinancialServicesHeaderComponent.propTypes = {
  t: PropTypes.func.isRequired,
  validationInfo: PropTypes.object.isRequired,
  wheelSizes: PropTypes.array.isRequired,
  onHeaderPropertyChange: PropTypes.func.isRequired,
  header: PropTypes.object.isRequired
};

export default withTranslation()(memo(OfferFinancialServicesHeaderComponent));
